import { api } from '@cma/app'
import {
  UpdateBrokerAccountMutation,
  UpdateBrokerAccountMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useUpdateBrokerAccount() {
  const queryClient = useQueryClient()
  return useMutation<
    UpdateBrokerAccountMutation,
    Error,
    UpdateBrokerAccountMutationVariables
  >(
    ({ input }) => {
      const query = gql`
        mutation UpdateBrokerAccount($input: UpdateBrokerAccountInput!) {
          updateBrokerAccount(input: $input) {
            account {
              id
              logo
              phone
              officeAddress
            }
          }
        }
      `
      const variables = { input }
      return api<UpdateBrokerAccountMutation>({ query, variables })
    },
    {
      async onSuccess() {
        await Promise.all([
          queryClient.invalidateQueries(['broker']),
          queryClient.invalidateQueries(['brokerAgents']),
          queryClient.invalidateQueries(['brokerStates'])
        ])
      }
    }
  )
}
